import { Stack, styled, Typography } from '@mui/material';
import type { FC } from 'react';

import WelcomeSvg from '../../assets/welcome_pic.svg';
import { Logo } from './Logo';

interface WelcomeSideBarProps {
  title: string;
  subtitle: string;
}

export const WelcomeSideBar: FC<WelcomeSideBarProps> = ({
  title,
  subtitle,
}) => {
  return (
    <WelcomeContainer>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <ContentContainer sx={{ justifyContent: 'center', gap: 4 }}>
        <Stack
          sx={{
            gap: 0,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: 'secondary.darker',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
            }}
          >
            {subtitle}
          </Typography>
        </Stack>
        <Stack
          sx={{
            alignItems: 'center',
          }}
        >
          <img src={WelcomeSvg} width={250} />
        </Stack>
      </ContentContainer>
    </WelcomeContainer>
  );
};

const WelcomeContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    width: '100%',
    height: '100vh',
    bgcolor: 'secondary.lighter',
  })
);

const LogoContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    pt: 3,
    pl: 2,
    pb: 8,
    flexShrink: 0,
  })
);

const ContentContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    flexGrow: 1,
    px: 4,
    mt: -26,
  })
);
